import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { DropdownModule } from "primeng/dropdown";'@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../../core/auth/services/auth.service';
import { AssesmentdetailsService } from '../../assesment-services/assesmentdetails.service';
import { ScoreHistoryResponse, TimePeriodFilter } from '../../assesment-const/assessment-details-models';
import { CustomGraphComponent } from "projects/patient/src/app/components/custom-graph/custom-graph.component";

@Component({
  selector: 'patient-assessment-history-graph',
  standalone: true,
  imports: [CommonModule, DropdownModule, FormsModule, CustomGraphComponent],
  templateUrl: './assessment-history-graph.component.html',
  styleUrl: './assessment-history-graph.component.css'
})
export class AssessmentHistoryGraphComponent implements OnInit {
  private authService = inject(AuthService);
  private assesmentdetailsService = inject(AssesmentdetailsService);

  patientId!: string;
  loading: boolean = true;
  scoreHistoryData: ScoreHistoryResponse | null = null;

  // Graph Data Bindings
  graphDates: string[] = [];
  graphValues: number[] = [];
  latestProgress: number = 0;
  isPositive: boolean = true;

  // Filter Configuration
  filterOptions = [
    { label: 'Weekly', value: TimePeriodFilter.Weekly },
    { label: 'Monthly', value: TimePeriodFilter.Monthly },
  ];
  selectedFilter: TimePeriodFilter = TimePeriodFilter.Monthly;

  ngOnInit() {
    this.authService.getUserProfile().subscribe((res) => {
      if (res?.PatientId) {
        this.patientId = res.PatientId;
        this.fetchGraphData();
      }
    });
  }

  fetchGraphData() {
    this.loading = true;
    this.assesmentdetailsService.getScoreHistory(this.patientId, this.selectedFilter).subscribe({
      next: (response) => {
        if (response && response.status === 200) {
          this.scoreHistoryData = response;
          this.processGraphData();
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to load graph history:', err);
        this.loading = false;
      }
    });
  }

  onFilterChange() {
    this.fetchGraphData();
  }

  private processGraphData() {
    if (!this.scoreHistoryData || !this.scoreHistoryData.pre_assessment_history) return;

    // API returns history in descending order. We want chronological order (ascending) for graphs.
    const sortedHistory = [...this.scoreHistoryData.pre_assessment_history].reverse();

    // Map data for custom graph
    this.graphDates = sortedHistory.map(item => this.formatDate(item.date));
    this.graphValues = sortedHistory.map(item => item.value);

    this.latestProgress = this.scoreHistoryData.progress_from_last_assessment;
    this.isPositive = this.scoreHistoryData.is_positive;
  }

  private formatDate(dateStr: string): string {
    // Basic mapping from "26-03-2026" to "26 Mar" based on standard requirements
    if (!dateStr || dateStr.length < 10) return dateStr;
    const parts = dateStr.split('-');
    if (parts.length === 3) {
      const day = parts[0];
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const monthIndex = parseInt(parts[1], 10) - 1;
      return `${day} ${monthNames[monthIndex]}`;
    }
    return dateStr;
  }

  getHintText(): string {
     if (this.latestProgress === 0) {
         return "Your health score has remained stable. Maintaining balanced nutrition and regular activity can help improve it over time.";
     }
     if (this.isPositive) {
         return "Great job! This could positively affect your nutrition habits, hydration levels, sleep cycle, or physical activity.";
     } else {
         return "This could negatively affect your nutrition habits, hydration levels, sleep cycle, or physical activity.";
     }
  }
}
